module.exports = __webpack_public_path__ + "img/logoppdb.284f16c3.png";